import React from "react";
import { Text, TextProps } from "react-native";
import { fonts } from "../styles/theme";

// Drop-in replacement for RN's Text that defaults to the app's BarisSans
// font. Pass a style with fontFamily to override the weight, e.g.
// style={{ fontFamily: fonts.bold }}.
const AppText: React.FC<TextProps> = ({ style, ...props }) => {
  return <Text style={[{ fontFamily: fonts.regular }, style]} {...props} />;
};

export default AppText;
